import { Requests } from "@/services/requests";

const ENDPOINTS = {
   EDIT: "credit-card/edit/"
};

const MSG = {
   EDIT_SUCCESS: "EDITADO com sucesso",
   ERROR_DEFAULT: "Erro ao fazer a requisição"
};
export default class CreditCard {
   constructor(request) {
      this.request = request;
      this.moduleName = "CreditCard";
      this.routes = {
         closing: {
            edit: this.editClosingDate.bind(this)
         }
      };
   }
   async makeRequest({ url, method, body, headers, expectedStatus }) {
      return Requests[method]({ url, body, headers }, expectedStatus);
   }

   async editClosingDate(payload) {
      const { id, ...bodyWithoutId } = payload;
      return this.makeRequest({
         url: ENDPOINTS.EDIT + id + "/",
         method: "PUT",
         body: bodyWithoutId,
         expectedStatus: {
            200: MSG.EDIT_SUCCESS,
            default: MSG.ERROR_DEFAULT
         }
      });
   }
}
